import { Col, Row } from 'react-bootstrap';
import Card from 'react-bootstrap/Card';
import { IoIosCheckmarkCircleOutline } from 'react-icons/io';

function ProcessCard({image, list, title, para}) {
  return (
    <Card className="shadow-sm rounded-4 border-0 p-md-3 pb-2 h-100 ">
      <Card.Img variant="top" src={image} className="img-fluid" />
      <Card.Body className="d-flex flex-column">
        <Card.Title className="mb-3 fw-bold">


{title}        </Card.Title>


<Row>
  {list?.map((l, i) => (
    <Col key={i} xs={6}>
      <p>
        <IoIosCheckmarkCircleOutline size={24} className="mb-1" color="var(--color4)" />
      <small className='ps-2'>

      
        {l}
      </small>
      </p>
    </Col>
  ))}
</Row>

        <div className="flex-grow-1">
          {para && <>{para}</>}
        
        </div>

    
      </Card.Body>
    </Card>
  );
}

export default ProcessCard;
